<template>
	<span v-if="parsedDate.date != null" class="fi-date">{{ formatted }}</span>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {parseDate, ParsedDate, smartDate} from "@t/util/DateUtil.ts";
import {injectEnv} from "@fd/Environment.ts";

const props = defineProps<{
	value?: string
}>();
const env = injectEnv();

const parsedDate = computed<ParsedDate>(() => parseDate(props.value));
const formatted = computed<string>(() => smartDate(parsedDate.value, env));
</script>

<style>

</style>